
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34 11.32a11.76 11.76 0 01-3.3.9A5.76 5.76 0 0033.23 9a11.53 11.53 0 01-3.65 1.4 5.74 5.74 0 00-9.94 3.93 5.66 5.66 0 00.15 1.31A16.3 16.3 0 018 9.67a5.68 5.68 0 00-.78 2.89 5.75 5.75 0 002.56 4.78 5.59 5.59 0 01-2.6-.72v.08a5.75 5.75 0 004.61 5.63 5.79 5.79 0 01-1.51.2 5.49 5.49 0 01-1.08-.1 5.75 5.75 0 005.36 4 11.51 11.51 0 01-7.13 2.46A12.44 12.44 0 016 28.8a16.25 16.25 0 008.81 2.58c10.56 0 16.34-8.76 16.34-16.35v-.74A11.58 11.58 0 0034 11.32z"}})])
          )
        }
      }
    